import { BarChart3, Shield, Zap, Globe } from "lucide-react";
import { useT } from "@/contexts/LanguageContext";

const WelcomePage = ({ onSignIn, onRegister, lang, onChangeLang }) => {
  const t = useT();

  return (
    <div className="welcome-page" data-testid="welcome-page">
      <div className="welcome-lang-bar">
        {["en", "fr", "es"].map((l) => (
          <button
            key={l}
            className={`lang-btn ${lang === l ? "active" : ""}`}
            onClick={() => onChangeLang(l)}
            data-testid={`welcome-lang-${l}`}
          >
            {l.toUpperCase()}
          </button>
        ))}
      </div>

      <div className="welcome-hero">
        <div className="welcome-logo-area">
          <img src="/logo.png" alt="CO2e Portal" className="welcome-logo-img" />
        </div>
        <h1 className="welcome-title" data-testid="welcome-title">
          <span className="welcome-title-line">
            {lang === "fr" ? "Optimisation Énergétique" : lang === "es" ? "Optimización Energética" : "Energy Optimization"}
          </span>
          <span className="welcome-title-amp">&amp;</span>
          <span className="welcome-title-line">
            {lang === "fr" ? "Émissions de Carbone" : lang === "es" ? "Emisiones de Carbono" : "Carbon Emissions"}
          </span>
          <span className="welcome-title-line">
            {lang === "fr" ? "Plateforme d'Audit" : lang === "es" ? "Plataforma de Auditoría" : "Audit Platform"}
          </span>
        </h1>
        <p className="welcome-subtitle">
          {lang === "fr"
            ? "Mesurez, analysez et réduisez votre empreinte carbone avec des audits complets pour les entreprises commerciales et résidentielles."
            : lang === "es"
            ? "Mida, analice y reduzca su huella de carbono con auditorías integrales para empresas comerciales y residenciales."
            : "Measure, analyze, and reduce your carbon footprint with comprehensive audits for commercial and residential enterprises."}
        </p>
        <div className="welcome-cta">
          <button className="btn btn-primary btn-lg" onClick={onSignIn} data-testid="welcome-sign-in-btn">
            {lang === "fr" ? "Se Connecter" : lang === "es" ? "Iniciar Sesión" : "Sign In"}
          </button>
          <button className="btn btn-secondary btn-lg" onClick={onRegister} data-testid="welcome-register-btn">
            {lang === "fr" ? "Créer un Compte" : lang === "es" ? "Crear Cuenta" : "Create Account"}
          </button>
        </div>
      </div>

      <div className="welcome-features">
        <div className="welcome-feature-card">
          <div className="welcome-feature-icon">
            <BarChart3 size={28} />
          </div>
          <h3>{lang === "fr" ? "Audits Multi-Départements" : lang === "es" ? "Auditorías Multi-Departamento" : "Multi-Department Audits"}</h3>
          <p>
            {lang === "fr"
              ? "Questionnaires détaillés couvrant bâtiments, opérations, transport, approvisionnement et administration."
              : lang === "es"
              ? "Cuestionarios detallados que cubren edificios, operaciones, transporte, adquisiciones y administración."
              : "Detailed questionnaires covering buildings, operations, transportation, procurement, and administration."}
          </p>
        </div>
        <div className="welcome-feature-card">
          <div className="welcome-feature-icon">
            <Zap size={28} />
          </div>
          <h3>{lang === "fr" ? "Données IoT en Temps Réel" : lang === "es" ? "Datos IoT en Tiempo Real" : "Real-Time IoT Data"}</h3>
          <p>
            {lang === "fr"
              ? "Intégration avec les compteurs PMC-53A-E pour la surveillance énergétique et la corrélation des données en direct."
              : lang === "es"
              ? "Integración con medidores PMC-53A-E para monitoreo energético y correlación de datos en vivo."
              : "Integration with PMC-53A-E power meters for live energy monitoring and data correlation."}
          </p>
        </div>
        <div className="welcome-feature-card">
          <div className="welcome-feature-icon">
            <Shield size={28} />
          </div>
          <h3>{lang === "fr" ? "Rapports CO2e" : lang === "es" ? "Informes CO2e" : "CO2e Reports"}</h3>
          <p>
            {lang === "fr"
              ? "Rapports PDF et Excel d'efficacité énergétique et d'émissions de carbone avec analyses consolidées."
              : lang === "es"
              ? "Informes PDF y Excel de eficiencia energética y emisiones de carbono con análisis consolidados."
              : "Energy efficiency and carbon emissions PDF & Excel reports with consolidated analytics."}
          </p>
        </div>
        <div className="welcome-feature-card">
          <div className="welcome-feature-icon">
            <Globe size={28} />
          </div>
          <h3>{lang === "fr" ? "Multilingue" : lang === "es" ? "Multilingüe" : "Multi-Language"}</h3>
          <p>
            {lang === "fr"
              ? "Interface et questionnaires complets disponibles en anglais, français et espagnol."
              : lang === "es"
              ? "Interfaz y cuestionarios completos disponibles en inglés, francés y español."
              : "Full interface and questionnaires available in English, French, and Spanish."}
          </p>
        </div>
      </div>

      <footer className="welcome-footer">
        <p>CO2e Portal &copy; {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
};

export default WelcomePage;
